export const NAME = 'reviewNoteDraggable';